"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitNav = exports.Sections = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const react_2 = require("@chakra-ui/react");
const UiKitIcons_1 = require("../../UiKitIcons");
const consistency_1 = require("../../consistency");
const UiKitContext_1 = require("../../UiKitContext");
const color_1 = require("../../color");
const COLOR_BACKGROUND = '0 0% 100%';
const COLOR_SHADOW = '0 0% 50%';
const OPENED_SIDEBAR_SIZE = 196;
const CLOSED_SIDEBAR_SIZE = 40;
const EASE_OUT_CIRC = 'cubic-bezier(0.075, 0.820, 0.165, 1.000)';
const LeftNavContainer = styled_1.default.div `
  position: fixed;
  left: 0;

  transition: width 0.8s ${EASE_OUT_CIRC};
  height: calc(100vh - 48px);
  flex-shrink: 0;

  margin: 0;
  padding: 16px 6px 16px 6px;

  background-color: ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.background : 'white')};
  box-shadow: 2px 0 12px rgba(17, 47, 78, 0.08);
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ isOpen }) => (isOpen ? 'width: 220px;' : 'width: 52px;')}
`;
exports.Sections = styled_1.default.div `
  background:
    linear-gradient(
      hsl(${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.backgroundHsl : COLOR_BACKGROUND)})
        33%,
      hsla(
        ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.backgroundHsl : COLOR_BACKGROUND)} / 0
      )
    ),
    linear-gradient(
        hsla(
          ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.backgroundHsl : COLOR_BACKGROUND)} /
            0
        ),
        hsl(
            ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.backgroundHsl : COLOR_BACKGROUND)}
          )
          66%
      )
      0 100%,
    radial-gradient(farthest-side at 50% 0, hsla(${COLOR_SHADOW} / 0.25), hsla(${COLOR_SHADOW} / 0)),
    radial-gradient(farthest-side at 50% 100%, hsla(${COLOR_SHADOW} / 0.25), hsla(${COLOR_SHADOW} / 0)) 0 100%; /* 2 */
  background-attachment: local, local, scroll, scroll; /* 2 */
  background-color: hsl(
    ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.backgroundHsl : COLOR_BACKGROUND)}
  ); /* 2 */
  background-repeat: no-repeat; /* 2 */
  ${({ isOpen }) => {
    const sidebarSize = isOpen ? OPENED_SIDEBAR_SIZE : CLOSED_SIDEBAR_SIZE;
    return `
      background-size: ${sidebarSize}px 30px, ${sidebarSize}px 30px, ${sidebarSize}px 10px, ${sidebarSize}px 10px;
    `;
}}
  flex: 1;
  overflow-y: scroll; /* 1 */
  scrollbar-width: none; /* 1 */
  -ms-overflow-style: none; /* 1 */

  &::-webkit-scrollbar {
    display: none; /* 1 */
  }
`;
const Stretch = styled_1.default.div `
  flex-shrink: 0;
  transition: width 0.8s ${EASE_OUT_CIRC};
  ${({ isOpen }) => (isOpen ? 'width: 220px;' : 'width: 52px;')}
`;
const SwitchContainer = styled_1.default.div `
  height: 4px;

  padding: 0 4px;
  margin: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  align-self: flex-end;
`;
const Circle = styled_1.default.div `
  position: relative;
  left: 22px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: ${({ useNewBranding }) => (useNewBranding ? '22px' : '24px')};
  height: ${({ useNewBranding }) => (useNewBranding ? '22px' : '24px')};
  border-radius: 12px;
  background-color: #fff;
  border-color: ${({ useNewBranding }) => (useNewBranding ? color_1.brandColors.sideNav.icon : '')};
  border-width: ${({ useNewBranding }) => (useNewBranding ? '1px' : '0')};
  box-shadow: 0 4px 12px 0 #112f4e14;

  cursor: pointer;

  &:hover {
    background-color: ${({ useNewBranding }) => useNewBranding ? consistency_1.consistency.gray05 : consistency_1.consistency.primaryBlue05};
  }
`;
const StyledMenuList = (0, styled_1.default)(react_2.MenuList) `
  background-color: white;
  box-shadow: 2px 0 12px rgba(17, 47, 78, 0.08);
  border: none;
`;
const StyledMenuItem = (0, styled_1.default)(react_2.MenuItem) `
  height: 36px;
  background-color: inherit;
  font-size: 14px;

  &:hover {
    background-color: ${consistency_1.consistency.gray04};
  }
`;
const UiKitNavSection = (props) => {
    const useNewBranding = (0, react_1.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const headingWhenClosedIsHorizontalLine = (0, react_1.useMemo)(() => (react_1.default.createElement(react_2.Box, { w: 'calc(100% - 24px)', h: 0, border: `1px solid ${consistency_1.consistency.gray05}`, m: '17px 12px 30px 12px', transition: `opacity 0.6s ${EASE_OUT_CIRC}`, opacity: props.isOpen ? 0 : 1 })), [props.isOpen]);
    const headingWhenOpenIsText = (0, react_1.useMemo)(() => (react_1.default.createElement(react_2.Heading, { color: useNewBranding ? color_1.brandColors.sideNav.heading : '', opacity: props.isOpen ? 1 : 0, size: "s", position: 'relative', top: '-30px', padding: '0 12px', margin: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', transition: `opacity 0.6s ${EASE_OUT_CIRC}` }, props.label)), [props.isOpen, props.label]);
    return (react_1.default.createElement(react_2.VStack, { pb: consistency_1.consistency.halfBuffer, spacing: '4px', align: 'stretch' },
        props.label && (react_1.default.createElement("div", { style: {
                overflow: 'hidden',
                height: '40px',
            } },
            headingWhenClosedIsHorizontalLine,
            headingWhenOpenIsText)),
        props.items.map((item, idx) => {
            if (item.kind === 'NavItemMenu') {
                return (react_1.default.createElement(UiKitNavSubSection, { key: idx, items: item.items, label: item.label, icon: item.icon, isOpen: props.isOpen, linkWrapperComponent: props.linkWrapperComponent }));
            }
            else {
                return (react_1.default.createElement("div", { key: idx, "data-tip": !props.isOpen ? item.label : undefined, "data-for": "sidebar-tooltip" },
                    react_1.default.createElement(Entry, { isActive: item.isActivePage, icon: item.icon, isOpen: props.isOpen, label: item.label, isMenu: false, path: item.path, linkWrapperComponent: props.linkWrapperComponent })));
            }
        })));
};
const UiKitNavSubSection = (props) => {
    const { isOpen: isMenuOpen, onOpen, onClose } = (0, react_2.useDisclosure)();
    if (props.items.length === 0) {
        return null;
    }
    const LinkWrapperComponent = props.linkWrapperComponent;
    return (react_1.default.createElement("div", { onMouseEnter: onOpen, onClick: onOpen, onMouseLeave: onClose },
        react_1.default.createElement(react_2.Menu, { isOpen: isMenuOpen, onClose: onClose, placement: "right" },
            react_1.default.createElement(react_2.MenuButton, { w: '100%', backgroundColor: 'inherit', whiteSpace: 'nowrap', cursor: 'pointer', borderRadius: consistency_1.consistency.borderRadius, "data-tip": !props.isOpen ? props.label : undefined, "data-for": "sidebar-tooltip" },
                react_1.default.createElement(Entry, { isActive: false, icon: props.icon, label: props.label, isOpen: props.isOpen, isMenu: true, isMenuOpen: isMenuOpen, path: '', linkWrapperComponent: props.linkWrapperComponent })),
            react_1.default.createElement(StyledMenuList, null, props.items.map((item, idx) => (react_1.default.createElement(LinkWrapperComponent, { path: item.path, key: idx },
                react_1.default.createElement(StyledMenuItem, null,
                    react_1.default.createElement(react_2.Box, { color: consistency_1.consistency.gray90 }, item.label)))))))));
};
const getIconSizeForLabel = (label, useNewBranding) => {
    const size = {
        w: 18,
        h: 18,
    };
    if (label === 'Datavanter') {
        if (useNewBranding) {
            size.w = 180;
            size.h = 180;
        }
        else {
            size.w = 22;
            size.h = 24;
        }
    }
    if (label === 'Privacy Hub') {
        size.w = 14;
        size.h = 18;
    }
    return size;
};
const Entry = (props) => {
    const useNewBranding = (0, react_1.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const LinkWrapperComponent = props.linkWrapperComponent;
    const menuIndicator = props.isMenu && (react_1.default.createElement(react_2.Icon, { justifySelf: 'flex-end', boxSize: "12px", mr: "8px" },
        react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.ArrowForwardIos, null)));
    const IconSVG = props.icon;
    const iconSize = getIconSizeForLabel(props.label, useNewBranding);
    const iconJSX = (react_1.default.createElement(react_2.Icon, { width: `${iconSize.w}px`, height: `${iconSize.h}px`, viewBox: `0 0 ${iconSize.w} ${iconSize.h}`, boxSize: '18px', color: useNewBranding ? (props.isActive ? color_1.brandColors.sideNav.activeLinkFont : color_1.brandColors.sideNav.icon) : '' },
        react_1.default.createElement(IconSVG, null)));
    let backgroundColor = props.isActive
        ? useNewBranding
            ? color_1.brandColors.sideNav.activeLinkBackground
            : consistency_1.consistency.primaryBlue05
        : 'inherit';
    const oldBrandColor = props.isActive ? consistency_1.consistency.primaryBlue50 : consistency_1.consistency.gray90;
    const newBrandColor = props.isActive ? color_1.brandColors.sideNav.activeLinkFont : color_1.brandColors.sideNav.font;
    let fontColor = useNewBranding ? newBrandColor : oldBrandColor;
    const hoverColor = useNewBranding ? color_1.brandColors.sideNav.hoverFont : '';
    if (props.isMenuOpen) {
        backgroundColor = consistency_1.consistency.gray05;
        fontColor = useNewBranding ? color_1.brandColors.sideNav.hoverFont : '';
    }
    return (react_1.default.createElement(react_2.LinkBox, null,
        react_1.default.createElement(LinkWrapperComponent, { path: props.path },
            react_1.default.createElement(react_2.HStack, { ref: props.ref, w: '100%', backgroundColor: backgroundColor, color: fontColor, fontSize: '14px', justifyContent: 'flex-start', whiteSpace: 'nowrap', cursor: 'pointer', overflow: 'hidden', transition: useNewBranding ? '' : `background-color 1s ${EASE_OUT_CIRC}`, align: 'center', height: useNewBranding ? '36px' : '40px', spacing: 0, p: 0, borderRadius: useNewBranding ? '0 18px 18px 0' : consistency_1.consistency.borderRadius, _hover: {
                    backgroundColor: props.isActive ? '' : consistency_1.consistency.gray05,
                    color: hoverColor,
                } },
                useNewBranding ? (react_1.default.createElement(react_2.Box, { w: '4px', h: '36px', backgroundColor: props.isActive ? color_1.brandColors.sideNav.activeLinkAccent : 'inherit', left: 0, top: 0 })) : null,
                react_1.default.createElement(react_2.HStack, { spacing: consistency_1.consistency.halfBuffer, p: "10px", pl: "6px", w: "calc(100% - 4px)" },
                    iconJSX,
                    react_1.default.createElement(react_2.Box, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flex: 1,
                            transition: `opacity 0.6s ${EASE_OUT_CIRC}`,
                            opacity: props.isOpen ? 1 : 0,
                        } }, props.label),
                    menuIndicator)))));
};
const UiKitNav = (props) => {
    const handleToggleOpen = (0, react_1.useCallback)(() => props.setIsOpen(!props.isOpen), [props]);
    const useNewBranding = (0, react_1.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const switchColor = useNewBranding ? color_1.brandColors.sideNav.icon : consistency_1.consistency.primaryBlue50;
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement(LeftNavContainer, { isOpen: props.isOpen, useNewBranding: useNewBranding },
            react_1.default.createElement(exports.Sections, { isOpen: props.isOpen, useNewBranding: useNewBranding }, props.navTop.sections.map((section, idx) => (react_1.default.createElement(UiKitNavSection, { key: idx, ...section, isOpen: props.isOpen, linkWrapperComponent: props.linkWrapperComponent })))),
            react_1.default.createElement(react_2.Box, null,
                react_1.default.createElement(SwitchContainer, null,
                    react_1.default.createElement(Circle, { onClick: handleToggleOpen, useNewBranding: useNewBranding },
                        props.isOpen && (react_1.default.createElement(react_2.Icon, { color: switchColor, boxSize: "12px" },
                            react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.ArrowBackIos, null))),
                        !props.isOpen && (react_1.default.createElement(react_2.Icon, { color: switchColor, boxSize: "12px" },
                            react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.ArrowForwardIos, null))))),
                props.middleAdditionalContent,
                props.navBottom.datavanterLinks && (react_1.default.createElement(UiKitNavSubSection, { icon: useNewBranding ? UiKitIcons_1.UiKitIcons.Global.OneDatavantLogo : UiKitIcons_1.UiKitIcons.Global.Logo, label: "Datavanter", items: props.navBottom.datavanterLinks, isOpen: props.isOpen, linkWrapperComponent: props.linkWrapperComponent })),
                props.navBottom.singleSettingsLink && (react_1.default.createElement(UiKitNavSection, { items: [props.navBottom.singleSettingsLink], isOpen: props.isOpen, linkWrapperComponent: props.linkWrapperComponent })),
                props.navBottom.manySettingsLinks && (react_1.default.createElement(UiKitNavSubSection, { icon: UiKitIcons_1.UiKitIcons.SideMenu.Settings, label: props.navBottom.manySettingsLinks.label, items: props.navBottom.manySettingsLinks.items, isOpen: props.isOpen, linkWrapperComponent: props.linkWrapperComponent })),
                props.additionalContent)),
        react_1.default.createElement(Stretch, { isOpen: props.isOpen })));
};
exports.UiKitNav = UiKitNav;
